import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TaComunicazioniComponent } from './ta-comunicazioni.component';

const routes: Routes = [{
  path: '', component: TaComunicazioniComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TaComunicazioniRoutingModule { }
